"use client"

import { useState, Suspense } from "react"
import { Sidebar } from "@/components/sidebar"
import { cn } from "@/lib/utils"
import { DashboardHeader } from "./DashboardHeader"



export function DashboardShell({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false)

  return (

    <div className="flex h-screen bg-gray-50 dark:bg-gray-950 transition-colors overflow-hidden">
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
      />

      <div
        className={cn(
          "flex flex-col flex-1 transition-all duration-200",
          collapsed ? "ml-16" : "ml-48"
        )}
      >
        {/* Sticky Header */}
        <Suspense fallback={<div className="h-16 border-b bg-white dark:bg-gray-900 shadow-sm" />}>
          <DashboardHeader />
        </Suspense>

        {/* Scrollable Content Area */}
        <main className="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-950 transition-colors">
          {children}
        </main>
      </div>
    </div>


  )
}
